import React, { useState } from 'react';
import PropTypes from 'prop-types';

import {
  Backdrop,
  Button,
  Card,
  CardContent,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from '@material-ui/core';
import { useStyles } from './styles';
import ModalSignatureDetails from './ModalSignatureDetails';

function AberturaEmpresaInfo({ plano }) {
  const classes = useStyles();

  const [open, setOpen] = useState(false);

  const toggleModal = () => {
    setOpen((currentOpen) => !currentOpen);
  };

  return (
    <>
      <div>
        <Dialog
          scroll="paper"
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
          className={classes.modal}
          open={open}
          onClose={toggleModal}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <DialogContent dividers>
            <ModalSignatureDetails plano={plano} />
          </DialogContent>
          <DialogActions>
            <Button
              type="button"
              className={classes.submit}
              onClick={toggleModal}
            >
              CONTINUAR
            </Button>
          </DialogActions>
        </Dialog>
      </div>
      <Card className={classes.cardSignatureIntention}>
        <CardContent>
          <Typography onClick={toggleModal} className={classes.signatureText}>
            Sua assinatura será ativada após a conclusão do processo de abertura
            de empresa. Clique aqui para saber mais!
          </Typography>
        </CardContent>
      </Card>
    </>
  );
}

AberturaEmpresaInfo.propTypes = {
  plano: PropTypes.shape({
    nome: PropTypes.string,
    descricao: PropTypes.string,
    valor: PropTypes.number,
  }),
};

export default AberturaEmpresaInfo;
